/**
 * @fileoverview A "glue" hook for the PDF reading view.
 * It connects the paragraph data management (`usePdfParagraphs`),
 * the PDF-specific selection event context (`usePdfSelectionEventHandler`),
 * and the low-level selection logic (`usePdfTextSelection`).
 */
import { usePdfSelectionEventHandler } from '../contexts/PdfSelectionEventContext.js';
import { usePdfParagraphs } from '../../contexts/PdfParagraphsContext.js';
import { usePdfTextSelection } from './usePdfTextSelection.js';
/**
 * A business-logic hook for the PDF original text view.
 * It orchestrates data flow between paragraph contexts and selection hooks.
 */
export function usePdfOriginalTextView(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_params) {
    // 1. Get the event handler from the new, PDF-specific context.
    const { onSelectionChange } = usePdfSelectionEventHandler();
    // 2. Get the complete paragraph map from the paragraph context.
    const { paragraphMap } = usePdfParagraphs();
    // 3. Instantiate the low-level selection hook, passing them both in.
    //    The hook is now extremely simple, as all complex logic has been
    //    delegated to the contexts and the child hook.
    const { handleSelection } = usePdfTextSelection({
        onTextSelect: onSelectionChange,
        paragraphMap: paragraphMap,
    });
    return {
        handlePdfSelection: handleSelection,
    };
}
//# sourceMappingURL=usePdfOriginalTextView.js.map